import React from "react";

import Hero from "./Hero";
import About from "./About";

import WhyChooseUs from "./WhyChooseUs";
import OurService from "./OurService";
import Testimonials from "./Testimonials";
import usePageTitle from "../components/usePageTitle";
const Homepage = () => {
  usePageTitle("Home");
  return (
    <div>
      <Hero />
      <About />
      <OurService />
      <WhyChooseUs />
      {/* <Testimonials /> */}
    </div>
  );
};

export default Homepage;
